export const rmtCustomImpressionEvent = "rmt-impression";
export const rmtCustomClickEvent = "rmt-click";

export const defaultClickEvent = "suchergebnisartikelclicked";